import { Config } from "@/shared/config";

const themeServiceUri = Config.ThemeServicebaseUri;

export default {
  get themeV1 (): string {
    return `${themeServiceUri}/themeservice/v1`;
  },
  getAllThemes () {
    return `${this.themeV1}/theme-management`;
  },
  getTheme (themeId: number) {
    return `${this.themeV1}/theme-management/${themeId}`;
  },
  updateTheme () {
    return `${this.themeV1}/theme-management`;
  },
  searchTheme () {
    return `${this.themeV1}/theme-management/searchThemes`;
  },
  getEmployerTheme (employerId: number) {
    return `${this.themeV1}/employer/${employerId}/theme`;
  },
  saveEmployerTheme () {
    return `${this.themeV1}/employer/saveemployertheme`;
  },
  getPartnerTheme (partnerId: number | string) {
    return `${this.themeV1}/partner/${partnerId}/theme`;
  },
  savePartnerTheme (partnerId: number | string, themeId: number) {
    return `${this.themeV1}/partner/${partnerId}/theme/${themeId}/save`;
  },
  deletePartnerTheme (partnerId: number | string, partnerThemeId: number) {
    return `${this.themeV1}/partner/${partnerId}/theme/${partnerThemeId}/remove`;
  },
  getActiveThemes () {
    return `${this.themeV1}/theme-management/get-all-active`;
  },
  getThemeForUser (employerId: number, partnerId: number) {
    return `${this.themeV1}/user/${partnerId}/get-user-theme/${employerId}`;
  }
};
